import { jsx as c, jsxs as y } from "../../_virtual/jsx-runtime.mjs";
import I, { useMemo as a, useCallback as l } from "react";
import d from "../../depend/classnames/index.mjs";
import N from "../ReoIcon/ReoIcon.mjs";
import "../../depend/rc-notification/es/Notifications.mjs";
import C from "../../depend/rc-notification/es/Notice.mjs";
import { assignInlineVars as g } from "../../depend/@vanilla-extract/dynamic/dist/vanilla-extract-dynamic.esm.mjs";
import { DEFAULT_ANIMATION_DURATION as D, ANIMATION_INIT_OFFSET as x, messageIconInfo as r } from "./lib/constants.mjs";
import { reoMessageItem as A, animationFadeOutDelay as O } from "./css/ReoMessage.mjs";
const S = I.memo((e) => {
  const i = a(() => `${e.duration - D}s`, [e.duration]), o = a(() => {
    const t = {
      ...e.style,
      ...g({
        [O]: i
      })
    };
    return e.animationDirection && (t.transform = `translateY(${x[e.animationDirection]})`), t;
  }, [i, e.animationDirection, e.style]), m = a(() => e.icon ? e.icon : /* @__PURE__ */ c(
    N,
    {
      width: "20px",
      name: r[e.type].name,
      color: r[e.type].color
    }
  ), [e.icon, e.type]), u = a(() => /* @__PURE__ */ y(
    "div",
    {
      style: o,
      className: d(A, e.className),
      children: [
        m,
        e.content
      ]
    }
  ), [o, m, e.className, e.content]), f = l((t) => {
    var n;
    (n = e.onClick) == null || n.call(e, t), t.stopPropagation();
  }, [e]), s = l((t) => {
    var n;
    (n = e.onClose) == null || n.call(e, t);
  }, [e]);
  return /* @__PURE__ */ c(
    C,
    {
      eventKey: e.eventKey,
      prefixCls: e.prefixCls,
      duration: e.duration,
      content: u,
      onClick: f,
      onNoticeClose: s
    }
  );
});
export {
  S as ReoMessagePurePanel
};
//# sourceMappingURL=ReoMessagePurePanel.mjs.map
